import { getErrorCodeFromUnknown } from "./ErrorParsers";

/**
 * Framework-defined subtypes for `AtomErrors.InternalError`.
 *
 * These are canonical string error codes for framework-internal failures. They
 * are separate from domain-specific string codes such as `user-service/...`,
 * which can also travel through `AtomErrors.InternalError`.
 */
export enum InternalErrors {
  NoActingUser = "framework/internal/no-acting-user",
  MissingContextEntry = "framework/internal/missing-context-entry",
  InsufficientContext = "framework/internal/insufficient-context",
  CannotSpawnVirtualAtom = "framework/internal/cannot-spawn-virtual-atom",
  CannotSpawnWithoutLocking = "framework/internal/cannot-spawn-without-locking",
  CannotCommitWithoutLocking = "framework/internal/cannot-commit-without-locking",
  CannotCommitTwice = "framework/internal/cannot-commit-twice",
  CannotDirectlyChangeVirtualAtoms = "framework/internal/cannot-directly-change-virtual-atoms",
  InfiniteLoop = "framework/internal/infinite-loop",
  TryingToCommitFailedTransaction = "framework/internal/trying-to-commit-failed-transaction",
  ContextOverrideMismatch = "framework/internal/context-override-mismatch",
  HashMismatch = "framework/internal/hash-mismatch",
  MissingPayload = "framework/internal/missing-payload",
  ErrorDuringTransformation = "framework/internal/error-during-transformation",
  NoLockerSet = "framework/internal/no-locker-set",
  LockerNotFound = "framework/internal/locker-not-found",
  MissingModuleRef = "framework/internal/missing-module-ref",
  ContextChanged = "framework/internal/context-changed",
  InsufficientPermissions = "framework/internal/insufficient-permissions",
  Persistence = "framework/internal/persistence",
  Configuration = "framework/internal/configuration",
  MissingDependency = "framework/internal/missing-dependency",
  NotFound = "framework/internal/not-found",
  Validation = "framework/internal/validation",
  UnsupportedOperation = "framework/internal/unsupported-operation",
  Unavailable = "framework/internal/unavailable",
  ProviderRequestFailed = "framework/internal/provider-request-failed",
  InvariantViolation = "framework/internal/invariant-violation",
  Other = "framework/internal/other",
  AtomHasNoRelation = "framework/internal/atom-has-no-relation",
  Unknown = "framework/internal/unknown",
}

const internalErrorCodes = new Set<string>(Object.values(InternalErrors));

export function getInternalErrorCode(
  error: unknown,
): InternalErrors | undefined {
  const errorCode = getErrorCodeFromUnknown(error);
  if (!errorCode || !internalErrorCodes.has(errorCode)) {
    return undefined;
  }

  return errorCode as InternalErrors;
}
